export default __webpack_public_path__ + "static/media/siddartha.1d17f567.png";